const cestValue = value => value.replace(/\./g, '').replace(/^(\d{2})(\d{3})(\d{2})$/g, '$1.$2.$3');

export default cestValue;
